import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { estateGTNFactoriesSchemaObject } from '../estateGTNFactoriesSchema';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { Box } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const screenCode = 'ESTATEGTNFACTORIES';

export function GangAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Gang")
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [devisions, setDevisions] = useState()
    const contentRowNames = ["divisionName", "factoryName"]
    const [factories, setFactories] = useState();
    const [isViewTable, setIsViewTable] = useState(true);
    const [details, setDetails] = useState({
        dataArray: []
    });
    const [gang, setGang] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        factoryID: "0",
    });
    const [buttonName, setButtonName] = useState("Add");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add Estate GTN Factories',
        submitButtonName: 'Save'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });


    const schema = Joi.object(estateGTNFactoriesSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);


    useEffect(() => {
        trackPromise(
            getEstates(),
            getEsatesForDropDown()
        )
    }, [gang.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [gang.operationEntityID])


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITESTATEGTNFACTORIES');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });


        if (data && edit) {
            setTitle("Edit Gang");
            setGang(data);
            setDevisionForEdit()
            setButtonName("Update");

        } else {

            setTitle("Add Estate GTN Factories");
            var token = tokenService.getUserDetailsFromToken();
            setGang({
                ...gang,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllGroups()
        )
    }

    async function setDevisionForEdit() {
        const result = await services.getDivisions(data.operationEntityID)
        setDevisions(result)
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getFactoryByGroupID(gang.groupID);
        setFactories(factoryList);
    }


    function handleGroupChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0',
            factoryID: '0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            operationEntityID: target.value,
            collectionPointID: '0',
            factoryID: '0'
        })
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            collectionPointID: target.value,
            factoryID: '0'
        })
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            factoryID: target.value
        })

    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, estateGTNFactoriesSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    async function handleSave() {
        let detailsObject = {
            groupID: parseInt(gang.groupID.toString()),
            operationEntityID: parseInt(gang.operationEntityID.toString()),
            collectionPointID: parseInt(gang.collectionPointID.toString()),
            factoryID: parseInt(gang.factoryID.toString()),
        };

        let detail = [];
        detail = details.dataArray;
        if (gang.factoryID !== "0") {

            if (gang.collectionPointID == "0") {

                for (const [key, value] of Object.entries(devisions)) {
                    let userDetailsListArray = {
                        groupID: detailsObject.groupID,
                        operationEntityID: detailsObject.operationEntityID,
                        collectionPointID: key,
                        factoryID: detailsObject.factoryID,
                        factoryName: factories[gang.factoryID],
                        divisionName: value
                    };
                    detail.push(userDetailsListArray);
                }

            }
            else {
                let userDetailsListArray = {
                    groupID: detailsObject.groupID,
                    operationEntityID: detailsObject.operationEntityID,
                    collectionPointID: detailsObject.collectionPointID,
                    factoryID: detailsObject.factoryID,
                    factoryName: factories[gang.factoryID],
                    divisionName: devisions[gang.collectionPointID]
                };
                detail.push(userDetailsListArray);
            }
            setDetails({
                ...details,
                dataArray: detail
            });
            checkDisbursement();
        }
    }

    async function handleAllDataSave(e) {
        e.preventDefault()
        details.dataArray.forEach(x => {
            x.collectionPointID = parseInt(x.collectionPointID)
            x.userID = parseInt(tokenService.getUserIDFromToken())
        });
        const response = await services.EstateGTNFactoriesSave(details.dataArray)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)

    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/EstateGTNFactories' })
            }, 1500);
        }
    }

    const removeDetailByIndex = (collectionPointID) => {
        let tempArray = details.dataArray;
        const filteredArray = tempArray.filter((obj, index) => {
            return (index !== collectionPointID)
        })
        setDetails({
            dataArray: filteredArray
        });
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(gang.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getDevisions() {
        const result = await services.getDivisions(gang.operationEntityID)
        setDevisions(result)
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function checkDisbursement() {
        if (gang.factoryID === '0') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setGang({
            ...gang,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: 0,
            gangName: '',
            gangCode: '',
            isActive: true
        });
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Add"
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/EstateGTNFactories"

                                />
                            </div>
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={gang.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={gang.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Devision</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={gang.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Devision--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="factoryID"
                                            name="factoryID"
                                            value={gang.factoryID}
                                            onChange={(e) => handleFactoryChange(e.target)}>
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                </div>
                            </form>
                            <div className="table-responsive row-top-gap" hidden={isViewTable}>
                                <table className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Division</th>
                                            <th>Factory</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.dataArray.map((row, index) => (
                                                <tr>
                                                    <td>{row.divisionName}</td>
                                                    <td>{row.factoryName}</td>
                                                    <td>{<IconButton aria-label="delete" onClick={() => removeDetailByIndex(index)} >
                                                        <DeleteIcon />
                                                    </IconButton>}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Save"
                                        onClick={handleAllDataSave}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}